// Quantidade (+/−) grande pro totem; respeita itens divisíveis (kg/L).
// Produto Pesar na balança com balança no totem (26/10/2026): no lugar do
// +/− vem o peso da balança, sem digitar à mão (autoatendimento).
import { Minus, Plus } from "lucide-react";

import LeitorBalanca from "../../../balanca/LeitorBalanca";

export default function ControleQuantidade({ h }) {
  const { product, quantity, setQuantity } = h;
  if (h.balancaAtiva) {
    return (
      <div className="space-y-3" data-e2e="controle-quantidade">
        <div className="flex items-baseline gap-3">
          <span className="text-lg font-semibold text-zinc-300">Peso</span>
          <span className="text-4xl font-black text-zinc-100 tabular-nums" data-e2e="quantidade-valor">
            {h.pesadoBalanca ? `${quantity.toFixed(3).replace(".", ",")} kg` : "—"}
          </span>
        </div>
        <LeitorBalanca modulo={h.modulo} product={product} setQuantity={setQuantity}
          pesado={h.pesadoBalanca} setPesado={h.setPesadoBalanca} variante="escuro" />
      </div>
    );
  }
  const passo = product?.is_divisible ? (product.sale_unit === "kg" || product.sale_unit === "L" ? 0.1 : 0.5) : 1;
  const min = product?.is_divisible ? 0.001 : 1;
  const menos = () => setQuantity(Math.max(min, parseFloat((quantity - passo).toFixed(3))));
  const mais = () => setQuantity(parseFloat((quantity + passo).toFixed(3)));
  return (
    <div className="flex items-center gap-4" data-e2e="controle-quantidade">
      <span className="text-lg font-semibold text-zinc-300">Quantidade{product?.sale_unit && product.sale_unit !== "un" ? <span className="text-sm text-zinc-500 ml-1">({product.sale_unit})</span> : null}</span>
      <div className="flex items-center gap-3 bg-zinc-900 border border-zinc-700 rounded-full px-2 py-1.5">
        <button type="button" onClick={menos} disabled={quantity <= min} className="w-12 h-12 rounded-full bg-zinc-800 hover:bg-zinc-700 flex items-center justify-center disabled:opacity-30"><Minus className="w-6 h-6 text-zinc-100" /></button>
        <span className="min-w-[3rem] text-center text-3xl font-black text-zinc-100" data-e2e="quantidade-valor">{product?.is_divisible ? quantity.toFixed(3).replace(".", ",") : quantity}</span>
        <button type="button" onClick={mais} className="w-12 h-12 rounded-full bg-primary hover:bg-primary/90 flex items-center justify-center"><Plus className="w-6 h-6 text-primary-foreground" /></button>
      </div>
    </div>
  );
}
